export default class HearingTestConfiguration {
  constructor(configuration, headphoneType) {
    this.headphoneType = headphoneType
    this.channels = Object.values(this.headphoneType.channels)
    this.configuration = configuration.map(item => {
      return {
        frequency: item.freq,
        step: item.step
      }
    })
  }
  
  get frequencies () {
    return this.configuration.map(item => item.frequency)
  }
  
  get steps () {
    return this.configuration.map(item => item.step)
  }
  
}